import { useCallback } from 'react';
import { useUserContext } from '../../contexts';
import type { LinkResult, TransactionModel, TransactionsIntent } from './intents';
import { resolveTransactionModel } from './model';
import { buildTransactionsLink } from './buildTransactionsLink';

export function useTransactionModel(): TransactionModel {
  const { user, userLoading } = useUserContext();
  return resolveTransactionModel(user, userLoading);
}

export function useTransactionsLink() {
  const model = useTransactionModel();

  return useCallback(
    (intent: TransactionsIntent): LinkResult | null => {
      if (model === 'unresolved') return null;
      return buildTransactionsLink(model, intent);
    },
    [model],
  );
}
